module.exports = __webpack_public_path__ + "img/K.ccd79da1.jpg";